<app-nav [navItems]="navItems" />
<div class="static">
  <h1>Licensing policy</h1>
  <p>
    Welcome to the ImageBase.pro Licensing Policy. Below, we outline the terms
    and conditions that govern the use of images downloaded from our platform.
    By using our services, you agree to comply with these guidelines.
  </p>
  <p>
    <strong>1. Types of Licenses</strong>
  </p>
  <p>We offer two main types of licenses for our images:</p>
  <p><strong>1.1. Standard License</strong></p>
  <p>
    The Standard License grants you the right to use the image for the following
    purposes:
  </p>
  <ul>
    <li>Personal projects.</li>
    <li>
      Commercial projects with limited distribution (e.g., brochures, websites,
      social media posts, presentations).
    </li>
    <li>Digital use with a viewership of up to 500,000 individuals.</li>
  </ul>
  <p><strong>1.2. Extended License</strong></p>
  <p>The Extended License provides additional rights, including:</p>
  <ul>
    <li>Unlimited distribution for commercial purposes.</li>
    <li>
      Use in physical products for resale (e.g., posters, merchandise, apparel).
    </li>
    <li>Digital campaigns with unlimited viewership.</li>
    <li>Use in TV, film, or large-scale advertising.</li>
  </ul>

  <p><strong>2. Permitted Uses</strong></p>
  <p>Under both licenses, you can:</p>
  <ul>
    <li>Use images for websites, blogs, and social media.</li>
    <li>
      Incorporate images into marketing materials like flyers, banners, and
      email campaigns.
    </li>
    <li>Use images in presentations, reports, and educational materials.</li>
    <li>Edit and modify images to fit your creative projects.</li>
  </ul>
  <p><strong>3. Prohibited Uses</strong></p>
  <p>Regardless of the license type, the following uses are not permitted:</p>
  <ul>
    <li>Reselling or redistributing the original image file as-is.</li>
    <li>Claiming ownership or authorship of the image.</li>
    <li>Using the image in unlawful or defamatory contexts.</li>
    <li>Creating a competing stock image platform using our content.</li>
    <li>Sub-licensing the image to third parties.</li>
  </ul>
  <p><strong>4. RAW Format Usage</strong></p>
  <p>If you download RAW files, you are permitted to:</p>
  <ul>
    <li>Make extensive edits for your projects.</li>
    <li>Use them in both Standard and Extended License scenarios.</li>
  </ul>
  <p>
    However, redistribution or resale of unedited RAW files is strictly
    prohibited.
  </p>
  <p><strong>5. Licensing for Free Images</strong></p>
  <p>Free images are available under a limited-use license:</p>
  <ul>
    <li><strong>Personal Use:</strong> Unlimited.</li>
    <li>
      <strong>Commercial Use:</strong> Only with attribution to ImageBase.pro
      (unless stated otherwise).
    </li>
  </ul>
  <p>For unrestricted use, we recommend purchasing a paid license.</p>

  <p><strong>6. Copyright and Ownership</strong></p>
  <p>
    All images on ImageBase.pro are owned by <strong>V V G LLC</strong> and are
    distributed or sold under an agreement with <strong>DIGITAL DP LTD</strong>.
    <strong>DIGITAL DP LTD</strong> acts as the official and authorized
    distributor of the content available on the platform.
  </p>
  <p>
    All customer interactions, including sales, support, and payment processing,
    are managed by <strong>DIGITAL DP LTD</strong>.
  </p>

  <p><strong>7. Violations and Legal Action</strong></p>
  <p>
    Unauthorized use of our images, including any actions outside the scope of
    your license, may result in legal action. We actively monitor the misuse of
    our content to protect the rights of our creators and clients.
  </p>

  <p><strong>8. Questions and Support</strong></p>
  <p>
    If you have any questions about our licensing terms or need assistance in
    selecting the right license, please contact our support team via the
    <a routerLink="/contacts">Contact Us</a> page.
  </p>
  <p>
    Thank you for choosing ImageBase.pro! We are committed to providing you with
    high-quality content and flexible licensing options to meet your creative
    needs.
  </p>
</div>
